// removed by extract-text-webpack-plugin
module.exports = {"link":"_1CpU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/FooterLink/styles.scss
// module id = 428
// module chunks = 0